<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Architecture',

    metaInfo: { title: 'Architecture' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-field',
        'field-services',
        'photo-gallery',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
